import { DELAY } from '../const/time.const';
/**
 * Delay method decorator - delays execution of a decorated method by a given number of miliseconds
 * @param delay 500ms
 * @returns MethodDecorator
 * ```
 *  import { Delay } from '@emobg/web-utils';
 * ```
 * ```@Delay()```\
 * ```myDelayedMethod()```

 * ```@Delay(200)```\
 * ```myDelayedMethod()```
*/
export function Delay(delay = DELAY.short) {
    return function (_target, _propertyKey, descriptor) {
        const originalMethod = descriptor.value;
        descriptor.value = function (...args) {
            setTimeout(() => {
                originalMethod.apply(this, args);
            }, delay);
        };
        return descriptor;
    };
}
